import React, { useState } from "react";
import { InfiniteLoader } from "react-virtualized";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "../../../atoms/loading-spinner";
import { getHubTypeForModelNumber } from "shared/dist/utils/hardware";
import Explorer from "../../../../data-containers/explorer";
import URLState from "../../../../data-containers/url-state";
import ResizableTable from "../../../atoms/table/resizable-table";
import FleetLink from '../../../atoms/fleet-link';
// import { formatDate } from '../../../../lib/formatters';
import CONFIG from "../../../../lib/config";
import configureIcon from "../../../../../img/edit-icon.png";
import { arrowUpDown } from "../../../../lib/icons";
import TableHeaderWithIconContainer from "../../../atoms/TableHeaderWithIconContainer";

export default function () {
  const { fetchNextAvailableHubs, getAvailableHubs } = Explorer.useContainer();
  const { includeAllSubfleets } = URLState.useContainer();

  const availableState = getAvailableHubs();
  const [loadingNext, setLoadingNext] = useState(null);

  // eslint-disable-next-line
  const [tableHeight, setTableHeight] = useState(0);
  // eslint-disable-next-line
  const [tableInstance, setTableInstance] = useState({});

  let { loading, results=[], count } = availableState;

  results = results.map((inst) => {
    const { label = "Unknown model" } = getHubTypeForModelNumber(inst.hub_object.model_number) || {};
    inst.hub_object.type = label;
    return inst;
  });

  const mapToHub = ({ rowData, dataKey }) => rowData.hub_object[dataKey];
  const columns = [
    // {
    //   label: 'MFG Date',
    //   dataKey: 'dt_created',
    //   cellDataGetter: mapToHub,
    //   cellRenderer: ({cellData}) => {
    //     return <div className="column-inner">
    //       { formatDate({ d: new Date(cellData) }) }
    //     </div>;
    //   }
    // },
    {
      label: "SERIAL NUMBER",
      dataKey: "id",
      cellDataGetter: mapToHub,
      cellRenderer: ({ cellData }) => {
        return (
          <div className="column-inner" style={{ fontWeight: "bold" }}>
            {cellData}
          </div>
        );
      },
    },
    // {
    //   label: 'Model #',
    //   dataKey: 'model_number',
    //   cellDataGetter: mapToHub,
    //   cellRenderer: ({cellData}) => {
    //     return <div className="column-inner">
    //       { cellData }
    //     </div>;
    //   }
    // },
    {
      label: "TYPE",
      dataKey: "type",
      cellDataGetter: mapToHub,
      cellRenderer: ({ cellData }) => {
        return <div className="column-inner">{cellData}</div>;
      },
      headerRenderer: ({ label }) => (
        <TableHeaderWithIconContainer label={label} />
      ),
    },
    // {
    //   label: 'Hardware',
    //   dataKey: 'hardware',
    //   cellDataGetter: mapToHub,
    //   cellRenderer: ({cellData}) => {
    //     return <div className="column-inner">
    //       { cellData || 'unknown' }
    //     </div>;
    //   }
    // },
    // {
    //   label: 'OS',
    //   dataKey: 'os',
    //   cellDataGetter: mapToHub,
    //   cellRenderer: ({cellData}) => {
    //     return <div className="column-inner">
    //       { cellData || 'unknown' }
    //     </div>;
    //   }
    // },
    // {
    //   label: 'SW',
    //   dataKey: 'software',
    //   cellDataGetter: mapToHub,
    //   cellRenderer: ({cellData}) => {
    //     return <div className="column-inner">
    //       { cellData || 'unknown' }
    //     </div>;
    //   }
    // },
    {
      label: "CONFIGURE",
      dataKey: "id",
      cellDataGetter: mapToHub,
      cellRenderer: ({ cellData }) => {
        const { CONNECT_URL } = CONFIG.values;
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${CONNECT_URL}/logout?q=${cellData}`}
          >
            <img
              src={configureIcon}
              alt="configure"
              style={{ width: "20px" }}
            />
          </a>
        );
      },
    },
  ];

  if(includeAllSubfleets){
    columns.splice(
      2,
      0,
      {
        label: 'Fleet',
        dataKey: 'fleet',
        cellRenderer: ({cellData}) => {
          return <div className="column-inner">
            <FleetLink fleetId={cellData}>{cellData}</FleetLink>
          </div>;
        }
      }
    );
  }

  const passiveLoadNext = async () => {
    if (loading) {
      return;
    }
    setLoadingNext(true);
    await fetchNextAvailableHubs();
    setLoadingNext(false);
  };

  const noRowsRenderer = () => {
    const content = (function () {
      if (loading) {
        return <LoadingSpinner />;
      }
      return <h2>No results found</h2>;
    })();
    return <div className="explorer-status">{content}</div>;
  };

  return (
    <div className="explorer-locations explorer-available">
      {loading && <LoadingSpinner className="inline explorer-table-loading" />}
      <InfiniteLoader
        isRowLoaded={({ index }) => !!results[index]}
        loadMoreRows={passiveLoadNext}
        rowCount={count || 0}
        threshold={1}
      >
        {({ onRowsRendered, registerChild }) => (
          <ResizableTable
            id="available-table"
            className="available-table"
            noRowsRenderer={noRowsRenderer}
            columns={columns}
            list={results}
            loading={loading}
            onRowsRendered={onRowsRendered}
            ref={registerChild}
            setTableHeight={setTableHeight}
            setTableInstance={setTableInstance}
          />
        )}
      </InfiniteLoader>
      {loadingNext && (
        <div className="explorer-next-loading">
          <LoadingSpinner className="inline tiny" />
          &nbsp; Loading more rows&hellip;
        </div>
      )}
    </div>
  );
}
